import { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function AgePicker({ age, setAge }) {
  const [dob, setDob] = useState(null);

  const handleDateChange = (date) => {
    setDob(date);

    const today = new Date();
    let calculatedAge =
      today.getFullYear() - date.getFullYear();

    const m = today.getMonth() - date.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
      calculatedAge--;
    }

    setAge(calculatedAge);
  };

  const max18 = new Date();
  max18.setFullYear(max18.getFullYear() - 18);

  return (
    <div className="mb-6">
      <DatePicker
        selected={dob}
        onChange={handleDateChange}
        maxDate={max18}
        showYearDropdown
        showMonthDropdown
        dropdownMode="select"
        customInput={<AgeInput age={age} />}
      />
    </div>
  );
}

const AgeInput = forwardRef(({ age, onClick }, ref) => (
  <input
    ref={ref}
    onClick={onClick}
    readOnly
    value={age ? `${age}` : ""}
    placeholder="Select your DOB"
    className="w-full bg-transparent border-b border-gray-700
               focus:border-red-500 outline-none py-2 text-lg mt-1"
  />
));